<!-- NavButton.vue -->
<script setup lang="ts">
  import { INavButtonProps } from '@/types'
  import { Typography } from '@components/index'
  import loadIcon from '@utils/loadIcon'

  const props = defineProps<INavButtonProps>()
  const defaultIcon = props.icon ?? 'arrow-right-square-fill'
  const onClick = props.onClick ?? (() => {})
  const fontSize = props.fontSize ?? '18px'
  const marginRight = props.title.length > 0 ? '8px' : '0px'

  const handleClick = () => {
    onClick()
  }
</script>

<template>
  <div
    class="button-container"
    @click="handleClick"
  >
    <i
      class="icon-img"
      :class="loadIcon(defaultIcon)"
      :style="{ fontSize: fontSize, marginRight: marginRight }"
    />
    <Typography
      v-if="props.title.length > 0"
      variant="item"
    >
      {{ props.title }}
    </Typography>
  </div>
</template>

<style scoped lang="scss">
  .button-container {
    display: flex;
    align-items: center;
    cursor: pointer;
    line-height: 54px;
  }

  .icon-img {
    flex: 1;
  }
</style>
